import {deepOrange, green} from "@mui/material/colors";
import {CheckCircleOutline} from "@mui/icons-material";
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';

export function CompleteIcon(props: {
    mode: "card" | "column";
}) {
    return (
        <div style={{
            fontSize: "1.2rem",
            color: green["600"],
        }}>
            <CheckCircleOutline fontSize="inherit" color="inherit" />
        </div>
    )
}

export function AutomationIcon(props: {
    mode: "card" | "column";
}) {
    return (
        <div style={{
            fontSize: "1.2rem",
            color: deepOrange["400"],
        }}>
            <SettingsSuggestIcon fontSize="inherit" color="inherit" />
        </div>
    )
}